<script setup lang="ts">
import IconMaterialSymbolsLightCheck from '~icons/material-symbols-light/check';

import { CREDIT_HERO_BENEFITS } from '../content';
import { CreditSimulator } from '../CreditSimulator';
</script>

<template>
	<section id="simulador" class="bg-black text-[#FAFAFA]">
		<div
			class="mx-auto flex max-w-[1240px] flex-wrap items-start gap-14 px-6 pt-[132px] pb-22 lg:pt-[152px]"
		>
			<div class="min-w-0 flex-[1_1_460px] pt-6">
				<div
					class="text-[13px] font-medium tracking-[2px] text-beige uppercase"
				>
					PilarHomes Crédito
				</div>
				<h1
					class="mt-4.5 mb-0 font-[Inter,sans-serif] text-[clamp(38px,4.4vw,56px)] leading-[1.1] font-normal tracking-[-0.02em]"
				>
					O crédito certo para o seu próximo endereço.
				</h1>
				<p
					class="mt-6 mb-0 max-w-[540px] text-[19px] leading-[1.6] text-[#D6D6D6]"
				>
					Financiamento, consórcio e crédito com garantia de imóvel. Simule em 1
					minuto e receba propostas de vários bancos, comparadas por um
					especialista Pilar — sem custo para você.
				</p>
				<ul
					class="mt-8 mb-0 flex list-none flex-col gap-3.5 p-0 text-[16px] text-[#EDEDED]"
				>
					<li
						v-for="benefit in CREDIT_HERO_BENEFITS"
						:key="benefit"
						class="flex items-start gap-3"
					>
						<IconMaterialSymbolsLightCheck
							class="mt-px size-[22px] flex-none text-beige"
							aria-hidden="true"
						/>
						<span>{{ benefit }}</span>
					</li>
				</ul>
			</div>

			<CreditSimulator />
		</div>
	</section>
</template>
